window.luiReferenceControllers = window.luiReferenceControllers || [];
window.luiReferenceControllers.push(function (application, Stimulus) {
    application.register("comp_references_single_kkcg_creative", class extends Stimulus.Controller {
    get target() {
        return {
            intro: this.targets.find("intro")
        }
    }

    async connect() {
        let self = this;
        this._gsapTweens = [];
        await importScript([cdnjs.gsap, cdnjs.gsapScrollTrigger]);
        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: self.target.intro,
                scrub: true,
                pin: true,
                start: "top top",
                end: "+=400%"
            }
        });

        this._gsapTweens.push(tl);

        tl
            .from(self.target.intro.querySelector('[data-ref="top"]'),
                {
                    scale: 3.35,
                    ease: "none"
                }, 0)
            .from(self.target.intro.querySelector('[data-ref="bot"]'),
                {
                    scale: 3.125,
                    ease: "none"
                }, 0)
            .to({}, {duration: 0.25})
    }

    disconnect() {
        if (!this._gsapTweens) {
            return
        }

        this._gsapTweens.forEach((tween) => {
            if (tween.scrollTrigger) {
                tween.scrollTrigger.kill()
            }

            tween.kill()
        })

        this._gsapTweens = []
    }
});
});
window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
